import React, { useState } from "react";
import contact from "../assets/contact.png";
import { AiOutlineCheckCircle } from "react-icons/ai"; // Importing the green tick mark icon
import { FaFacebook } from "react-icons/fa";
import { FaInstagram } from "react-icons/fa6";

const ContactForm = () => {
  const [formData, setFormData] = useState({
    name: "",
    mobile: "",
    email: "",
  });

  const [isSubmitted, setIsSubmitted] = useState(false);
  const [error, setError] = useState("");

  const handleChange = (e) => {
    const { name, value } = e.target;

    if (name === "mobile") {
      if (/[^0-9]/.test(value)) {
        return;
      }

      setFormData({ ...formData, [name]: value });

      if (value.length === 10) {
        setError("");
      } else {
        setError("Please enter exactly 10 numeric digits.");
      }
    } else {
      setFormData({ ...formData, [name]: value });
    }
  };

  const handleSubmit = (e) => {
    e.preventDefault();

    if (formData.mobile.length !== 10) {
      setError("Please enter exactly 10 numeric digits.");
      return;
    }

    setError("");

    console.log("Form Data Submitted:", formData);

    const phoneNumber = "9160077777";
    const message = `Name: ${formData.name}\nMobile: ${formData.mobile}\nEmail: ${formData.email}`;

    const whatsappURL = `https://wa.me/${phoneNumber}?text=${encodeURIComponent(
      message
    )}`;

    window.open(whatsappURL, "_blank");

    setFormData({
      name: "",
      mobile: "",
      email: "",
    });

    setIsSubmitted(true);

    setTimeout(() => {
      setIsSubmitted(false);
    }, 4000);
  };

  return (
    <div>
      <div className="flex flex-col justify-between mx-auto border my-5 p-5 shadow md:flex-row">
        <div className="flex items-center justify-center bg-[#ffffff] py-[5%]">
          <div className="bg-[#454a44] text-white p-8 rounded-lg shadow-lg w-full max-w-md">
            <div className="text-left">
              <h2 className="text-lg font-semibold text-center">
                We'd Love to Hear From You
              </h2>
              <h2 className="text-2xl font-bold text-center mt-2">
                Get in Touch
              </h2>
            </div>

            <form onSubmit={handleSubmit} className="mt-6">
              <input
                type="text"
                name="name"
                placeholder="Name"
                value={formData.name}
                onChange={handleChange}
                className="w-full px-4 py-2 mb-4 rounded-md border border-gray-300 text-black focus:ring focus:ring-gray-500 focus:outline-none"
                required
              />
              <input
                type="tel"
                name="mobile"
                placeholder="Mobile"
                value={formData.mobile}
                onChange={handleChange}
                className="w-full px-4 py-2 mb-4 rounded-md border border-gray-300 text-black focus:ring focus:ring-gray-500 focus:outline-none"
                required
              />
              {error && <p className="text-red-500 text-xs mt-1">{error}</p>}
              <input
                type="email"
                name="email"
                placeholder="Email"
                value={formData.email}
                onChange={handleChange}
                className="w-full px-4 py-2 mb-4 rounded-md border border-gray-300 text-black focus:ring focus:ring-gray-500 focus:outline-none"
                required
              />
              <button
                type="submit"
                className="w-full bg-[#d9ded8] text-gray-700 py-2 rounded-md font-semibold hover:bg-[#c8cfc7] transition"
              >
                Submit
              </button>
            </form>

            <p className="text-[9px] text-gray-400 mt-4 text-center">
              <strong>Disclaimer:</strong> I authorize Siddhi Ganapathi Ventures
              LLP and its representatives to Call, SMS, Email, or WhatsApp me
              about its ventures, investment opportunities, and offers. This
              consent overrides any registration for DNC / NDNC.
            </p>
          </div>
        </div>

        <div>
          <img
            src={contact}
            className="py-[5%]"
            alt="Young couple inspecting a architectural building model for real estate investment with Siddhi Ganapathi Developers"
          />
          <div>
            {/* Contact Information */}
            <div className="flex flex-col items-center">
              {/* Email Section */}
              <div className="flex flex-col sm:flex-row mb-4 items-center sm:items-start text-center sm:text-left">
                <strong className="text-gray-800">Email:</strong>
                <div className="text-[14px] ml-1 flex flex-col gap-1">
                  <a
                    href="mailto:info@siddhiganapathi.com"
                    className="text-[#03833e] hover:text-[#454a44] transition-colors duration-200 cursor-pointer"
                    aria-label="Email info@siddhiganapathi.com"
                  >
                    info@siddhiganapathi.com
                  </a>
                  <a
                    href="mailto:cmd@siddhiganapathi.com"
                    className="text-[#03833e] hover:text-[#454a44] transition-colors duration-200 cursor-pointer"
                    aria-label="Email cmd@siddhiganapathi.com"
                  >
                    cmd@siddhiganapathi.com
                  </a>
                </div>
              </div>

              {/* Mobile Section */}
              <div className="flex flex-col sm:flex-row mt-2 sm:mt-0 mb-4 items-center sm:items-start text-center sm:text-left">
                <strong className="text-gray-800">Mobile:</strong>
                <div className="text-[14px] ml-1 flex flex-wrap gap-x-2">
                  <a
                    href="tel:+919160077777"
                    className="text-[#03833e] hover:text-[#454a44] transition-colors duration-200 cursor-pointer"
                    aria-label="Call +91 9160077777"
                  >
                    +91 9160077777
                  </a>
                  <span>,</span>
                  <a
                    href="tel:+918330077777"
                    className="text-[#03833e] hover:text-[#454a44] transition-colors duration-200 cursor-pointer"
                    aria-label="Call +91 8330077777"
                  >
                    +91 8330077777
                  </a>
                </div>
              </div>

              {/* Social Media Links */}
              <div className="flex flex-row mt-2">
                <div className="flex gap-4">
                  <a
                    href="https://www.instagram.com/accounts/login/?next=%2Fsiddhi_ganapathi%2F&source=omni_redirect"
                    target="_blank"
                    rel="noopener noreferrer"
                    aria-label="Instagram"
                    className="text-gray-600 hover:text-pink-600 transition-colors"
                  >
                    <FaInstagram className="text-2xl" />
                  </a>

                  <a
                    href="https://www.facebook.com/people/Siddhi-Ganapathi-Developers-Private-Limited/61574220923381/"
                    target="_blank"
                    rel="noopener noreferrer"
                    aria-label="Facebook"
                    className="text-gray-600 hover:text-blue-600 transition-colors"
                  >
                    <FaFacebook className="text-2xl" />
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* Success Dialog Box */}
        {isSubmitted && (
          <div className="fixed inset-0 flex items-center justify-center bg-gray-600 bg-opacity-50 z-50">
            <div className="bg-white p-6 rounded-lg shadow-lg w-[90%] max-w-sm text-center">
              <AiOutlineCheckCircle className="text-green-500 text-5xl mb-4 text-center" />
              <h3 className="text-xl font-semibold text-gray-700">
                Our team will contact you soon!
              </h3>
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default ContactForm;